import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { AdminContext } from 'context/AdminContext'

export default function OrganizationOverrideBanner() {

    const simulationClockDayOffset = useSelector((state) => state.simulationClock.simulationClockDayOffset)
    const overrideOrganizationLogo = useSelector((state) => state.admin.overrideOrganizationLogo)
    const overrideOrganizationName = useSelector((state) => state.admin.overrideOrganizationName)

    const { ClearOrganizationOverride, ShowOrganizationDirectoryModal } = useContext(AdminContext)

    return (
        <div 
            className={`
                fixed left-0 w-full z-50 
                ${simulationClockDayOffset !== 0 ? 'top-[44px]' : 'top-0'}
            `}
        >
            <div className='w-full h-[44px] shrink-0 overflow-hidden flex items-center bg-zinc-950 border-b border-zinc-700 px-3 gap-x-2 text-zinc-100'>
                <p className='pl-1 text-xs font-semibold uppercase tracking-wide text-zinc-400 w-52'>
                    Organization Override
                </p>

                <div className='flex-1' />

                <img 
                    src={overrideOrganizationLogo} 
                    alt="Override Organization Logo" 
                    className="w-6 h-6 rounded-full object-cover bg-zinc-100 border border-zinc-600" 
                />

                <div className='text-sm sm:text-base font-bold truncate'>
                    {overrideOrganizationName} 
                </div>

                <div className='flex-1' />

                <div className='w-52 flex gap-x-2 justify-end'>
                    <button 
                        className='w-20 h-7 bg-zinc-800 hover:bg-zinc-700 border border-zinc-600 flex items-center justify-center rounded-xl transition-colors'
                        onClick={ShowOrganizationDirectoryModal}
                    >
                        <p className='text-xs text-zinc-100'>Swap</p>
                    </button>

                    <button 
                        className='w-20 h-7 bg-zinc-800 hover:bg-zinc-700 border border-zinc-600 flex items-center justify-center rounded-xl transition-colors'
                        onClick={ClearOrganizationOverride}
                    >
                        <p className='text-xs text-zinc-100'>Clear</p>
                    </button>
                </div>
            </div>
        </div>
    )
}